import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'
import Joi from 'joi'

import { EntityConstants } from 'constants/EntityConstants'
import { DriverDetailsPhonePattern } from 'constants/RegExConstants'

const phoneValidator = (value: string, helpers: Joi.CustomHelpers) => {
  if (!value || value.trim() === '' || /^\+\d{1,4}$/.test(value.trim())) {
    return ''
  }

  const phonePattern = new RegExp(DriverDetailsPhonePattern)
  if (!phonePattern.test(value)) {
    return helpers.error('invalid.phone.number')
  }

  const phoneUtil = PhoneNumberUtil.getInstance()
  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(value)
    const isValid = phoneUtil.isValidNumber(parsedNumber)

    if (!isValid) {
      return helpers.error('invalid.phone.number')
    }

    const e164 = phoneUtil.format(parsedNumber, PhoneNumberFormat.E164)
    const normalizedInput = value.replace(/\s+/g, '')

    if (normalizedInput.startsWith('+') && normalizedInput !== e164) {
      return helpers.error('invalid.international.format')
    }
  } catch (error) {
    console.error('Error validating phone number:', error)
    return helpers.error('invalid.phone.number')
  }

  return value
}

const CreateUpdateCustomerAddressValidation = Joi.object({
  name: Joi.string().empty('').max(EntityConstants.MAX_NAME_LENGTH),
  city: Joi.string().empty('').max(EntityConstants.MAX_CITY_LENGTH),
  addressLine1: Joi.string().empty('').max(EntityConstants.MAX_ADDRESS_LENGTH),
  addressLine2: Joi.string()
    .allow(null)
    .empty('')
    .max(EntityConstants.MAX_ADDRESS_LENGTH)
    .optional(),
  postcode: Joi.string().empty('').max(EntityConstants.MAX_POSTCODE_LENGTH),
  email: Joi.string()
    .allow(null, '')
    .email({ tlds: false })
    .max(EntityConstants.MAX_EMAIL_LENGTH)
    .optional(),
  countryId: Joi.number(),
  telephoneNumber: Joi.string()
    .allow(null, '')
    .max(EntityConstants.MAX_TELEPHONE_NUMBER_LENGTH)
    .optional()
    .custom(phoneValidator)
    .messages({
      'invalid.phone.number': 'Invalid phone number format',
      'invalid.international.format':
        'Please enter the number without the leading zero (e.g. +44 7123 456789)',
    })
    .label('Telephone Number'),
  contact: Joi.string().allow(null, '').max(EntityConstants.MAX_PERSON_NAME_LENGTH).optional(),
})

export { CreateUpdateCustomerAddressValidation }
